import React from 'react';
import { Box, Link, Text } from '@chakra-ui/core';
import { UPLOAD_SIZE_ERROR } from '../helpers/fileUpload';

const FileUploadError = ({ error, ...props }) => {
  if (!error) return null;
  const message = Array.isArray(error) ? error.join(' ') : error;

  return (
    <Box role="alert" mt={2} fontSize="sm" {...props}>
      <Text color="error">{message}</Text>
      {message.includes(UPLOAD_SIZE_ERROR) && (
        <Text mt={1} color="semiDarkGray.900">
          Pour un PDF,{' '}
          <Link
            href="https://smallpdf.com/fr/compresser-pdf"
            isExternal
            color="coral.900"
            textDecoration="underline"
          >
            compressez-le avec Smallpdf
          </Link>
          , puis réessayez.
        </Text>
      )}
    </Box>
  );
};

export default FileUploadError;
